import { useTranslation } from 'react-i18next';
import type { ScannerStatus } from '@packages/shared-types';
import { StatusBadge, type StatusBadgeVariant } from '@/components/shared/StatusBadge';

const STATUS_TO_VARIANT: Record<ScannerStatus, StatusBadgeVariant> = {
  active: 'success',
  inactive: 'danger',
  maintenance: 'warning',
  charging: 'info',
};

export interface ScannerStatusBadgeProps {
  status: ScannerStatus;
  className?: string;
}

export function ScannerStatusBadge({
  status,
  className,
}: ScannerStatusBadgeProps): JSX.Element {
  const { t } = useTranslation();
  const variant = STATUS_TO_VARIANT[status];
  const label = t(`pages.scanners.statuses.${status}`);

  return (
    <StatusBadge variant={variant} className={className}>
      {label}
    </StatusBadge>
  );
}
